import gtm from 'vue-gtm'
import router from '../router'

const gtmPlugin = {
  install (Vue, options) {
    Vue.use(gtm, {
      debug: process.env.NODE_ENV !== 'production',
      vueRouter: router
    })
  }
}

export default gtmPlugin
